import React, { useMemo } from 'react';
import type { WidgetSize } from '../../types/dashboard';
import { BucketPerformanceList } from './BucketPerformanceList';
import {
  NOTIONAL_VOLUME_BUCKETS,
  buildBucketPerformance,
  getTradeNotionalVolume,
} from '../../lib/trades/dashboardBucketAnalytics';

interface PerformanceByVolumeWidgetProps {
  timeRange: 'week' | 'month' | 'year';
  size: WidgetSize;
  trades?: any[];
}

export const PerformanceByVolumeWidget: React.FC<PerformanceByVolumeWidgetProps> = ({
  timeRange, 
  size, 
  trades = [],
}) => {
  const perfData = useMemo(
    () => buildBucketPerformance({ trades, timeRange, buckets: NOTIONAL_VOLUME_BUCKETS, metric: getTradeNotionalVolume }),
    [timeRange, trades]
  );

  return (
    <BucketPerformanceList
      result={perfData}
      size={size}
      positiveValueClass="text-emerald-600"
      positiveBarClass="bg-emerald-600"
      pctFormatter={(item) => `${item.pct.toFixed(item.pct < 1 ? 2 : 1)}%`}
    />
  );
};